import { render } from "./Speed200.vue?vue&type=template&id=57ecc249"
import script from "./Speed200.vue?vue&type=script&lang=js"
export * from "./Speed200.vue?vue&type=script&lang=js"
script.render = render

export default script